import React, { useId } from 'react';
import { TextCommon } from '../../UI/Text/TextCommon';
import styles from '../Calculator.module.css';
import { getClearValue, getFormattedValue } from '../utils/format/format';
import { THandleUpdateValue } from '../utils/types';

type TInputCalculatorProps = {
    label?: string;
    name: string;
    value: string;
    isError?: boolean;
    isFrom?: boolean;
    handleUpdateValue: THandleUpdateValue;
    fontSize: string;
    subComponent: React.ReactNode;
    tabIndex?: number;
};

const CalculatorInput = React.memo(({ label, isError, value, handleUpdateValue, tabIndex, subComponent, name, isFrom, fontSize }: TInputCalculatorProps) => {
    const inputId = useId();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const clearValue = getClearValue(e?.target.value, value);
        handleUpdateValue(clearValue, e.target.name, isFrom);
    };
    const style = {
        '--calculator-input-font-size': fontSize || '40px',
        '--calculator-input-hover-color': isError ? 'var(--color-pink_100)' : 'var(--color-purple_100)',
        '--calculator-input-color': isError ? 'var(--color-pink_100)' : 'inherit',
    } as React.CSSProperties;

    return (
        <div className={styles.calculatorAmountBlock}>
            <TextCommon isWidget={false} content={label} options={{ variant: 'secondary', textColor: 'grey_72_lc', margin: { bottom: 4 } }} />
            <div className={styles.calculatorInputWrapper} style={style}>
                <input
                    data-test={`calculator_input_${isFrom ?? ''}`}
                    id={inputId}
                    name={name}
                    value={getFormattedValue(value)}
                    autoComplete="off"
                    onChange={handleChange}
                    type="text"
                    inputMode="decimal"
                    tabIndex={tabIndex}
                />
            </div>
            {subComponent}
        </div>
    );
});
export { CalculatorInput };
